import React, { useEffect, useState, useCallback } from 'react';
import { useTranslations } from '../../localization/useTranslations';
import CustomSnackbar from '../../components/CustomSnackbar';
import NewsletterCarousel from '../../newsletter-landing/components/NewsletterCarousel';
import useScrollbackAfterRedirect from '../../hooks/useScrollbackAfterRedirect';

const PremiumPage = () => {
  useScrollbackAfterRedirect(); // Restore scroll position if redirected from login
  const translations = useTranslations();

  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);

  const openSnackbar = useCallback((message: string) => {
    setSnackbarMessage(message);
    setIsSnackbarOpen(true);
  }, []);

  const onCloseSnackbar = () => {
    setIsSnackbarOpen(false);
  };

  // useEffect hook to handle pending actions and snackbar message
  useEffect(() => {
    // Retrieve the snackbar message type from session storage
    const snackbarMessageType = localStorage.getItem('snackbarMessage');

    // Function to get the message based on the message type stored before login
    const getMessage = () => {
      switch (snackbarMessageType) {
        case 'follow-author-success':
          return translations?.snackBarMessages?.subscribedAuthor || 'Author followed successfully!';
        case 'follow-author-error':
          return translations?.snackBarMessages?.failedSubscribeAuthor || 'Error following author. Please try again.';
        case 'follow-topic-success':
          return translations?.snackBarMessages?.subscribedTopic || 'Topic followed successfully!';
        case 'follow-topic-error':
          return translations?.snackBarMessages?.failedSubscribeTopic || 'Error following topic. Please try again.';
        default:
          return '';
      }
    };

    // If a snackbar message is found, display it and remove it from local storage
    if (snackbarMessageType) {
      openSnackbar(getMessage());
      localStorage.removeItem('snackbarMessage');
    }
  }, [openSnackbar, translations]);

  return (
    <>
      <CustomSnackbar message={snackbarMessage} open={isSnackbarOpen} onClose={onCloseSnackbar} />
      <div className="page-premium__follow-section">
        <NewsletterCarousel cardType="topic" openSnackbar={openSnackbar} />
        <NewsletterCarousel cardType="author" openSnackbar={openSnackbar} />
      </div>
    </>
  );
};

export default PremiumPage;
